import { formatPhoneNumber } from '@backrs_ui/common-ui';

export type ResumeContent = Readonly<{
  name: string;
  city?: string;
  state?: string;
  phone?: string;
  email?: string;
  linkedin?: string;
  educationContent: string;
  workExperienceContent: string;
  leadershipContent: string;
  skillsContent: string;
}>;

export const createHeader = ({
  name,
  city,
  state,
  phone,
  email,
  linkedin,
}: {
  name: string;
  city?: string;
  state?: string;
  phone?: string;
  email?: string;
  linkedin?: string;
}) => {
  const location = [city, state].filter(Boolean).join(', ');
  const formattedPhone = phone ? formatPhoneNumber(phone) : '';
  const contactInfo = [formattedPhone, email, linkedin].filter(Boolean);

  const contactLine = contactInfo.length > 0 ? contactInfo.join(' | ') : '';

  return `
## ${name}
${location}${location && contactLine ? ' | ' : ''}${contactLine}`;
};

export const createFullResume = (content: ResumeContent) => {
  const header = createHeader({
    name: content.name,
    city: content.city,
    state: content.state,
    phone: content.phone,
    email: content.email,
    linkedin: content.linkedin,
  });

  return `${header}
  
${content.educationContent}
${content.workExperienceContent}
${content.leadershipContent}
${content.skillsContent}`;
};
